import React from "react";
import "../styles/CryptoTopBar.css";
import { useGame } from "../GameContext";
const TopBar: React.FC = () => {
  const { message, setHelpPanelOpen } = useGame();
  return (
      <div className="crypto-top-bar">
        <a className="crypto-logo" href="https://kotobot.app/index.html">
          <img
             title ="На главную"
            className="crypto-logo"
            src="/img/kotobot.svg"
            alt="Kotobot logo"
          />
        </a>
        <div className="crypto-message-bar">{message}</div>
        <img
          className="crypto-icon"
          alt="Помощь"
          src="/img/help-fix.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>
  );
};

export default TopBar;
